<template>
<div class="dot_category">
    <div class="dot_wrap">
        
        <div class="commom_dot">
            <p class="dot_two">{{textTwo}}</p>
        </div>
        <div class="commom_dot">
            <p class="dot_one">{{textOne}}</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'dot-category',
  components: {},
  props: {
    textOne: {
        type:String,
        default: '视频'
    },
    textTwo: {
        type:String,
        default: '文章'
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.dot_category {
    width: 100%;
    .dot_wrap {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 17px;
        line-height: 17px;
        .commom_dot {
            p {
                font-size: 12px;
                color: #666;
                position: relative;
                &::before{
                    position: absolute;
                    content: '';
                    width: 8px;
                    height: 8px;
                    // border: 1px solid red;
                    border-radius: 50%;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -12px;
                }
            }
            .dot_one {
                &::before {
                    background-color: #ff8340;
                }
            }
            .dot_two {
                &::before {
                    background-color: #ffd600;
                }
            }
            &:first-child {
                margin-right: 38px;
            }
        }
    }
}
</style>
